import React, { useContext, useEffect, useMemo, useState } from "react";
import Navbar from "../../../../common/layout/Navbar";
import {
  empType,
  LicenseTypes,
  Operation,
} from "../../../../../utils/Enum.types";
import { Title } from "../../../../../stories/Title/Title";
import { Tab, Tabs, TextField } from "@mui/material";
import { Button } from "../../../../../stories/Button/Button";
import { useNavigate } from "react-router-dom";
import { a11yProps, TabPanel } from "../../../../../styles/Tabs";
import Plan from "./Plan";
import History from "../view/History";
import {
  CustomModal,
  toInputStandardDate,
  toStandardDate,
} from "../../../../../utils/UtilFunctions";
import {
  ViewAssetStylesRaiseTicket,
  ViewModalStyles,
} from "../../../../../styles/CustomModalStyles";
import ViewParticularProjectDetails from "../../DashBoardMapsView/dashboardcomponents/view/ViewParticularProjectDetails";
import EyeWhite from "../../../../../images/EyeWhite.svg";
import { AntSwitch } from "../../../../../styles/Switch";
import { CustomDrawer } from "../../../../../styles/CustomDrawerStyles";
import EmployeeAttendance from "./EmployeeAttendance";
import AttendedEmployeesList from "../view/AttendedEmployeesList";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  AddPmuCommentsResult,
  AddPmuCommentsVars,
  AtsMomMaster,
  AtsMomMasterOrder,
  GetMomAttCountResult,
  GetMomAttCountVars,
  UpdateViewedStatusResult,
  UpdateViewedStatusVar,
} from "../queries/types";
import { AddPmuComments, UpdateViewedStatus } from "../queries/mutations";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import { emptyIdAndModal, emptyMessage } from "../../../../../utils/constants";
import { msgType } from "../../../../../utils/types";
import MessageModal from "../../../../../customComponents/MessageModal";
import { GetMomAttCount, GetMomDetails } from "../queries/query";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import StarterKit from "@tiptap/starter-kit";
import { useEditor } from "@tiptap/react";
import TextAlign from "@tiptap/extension-text-align";
import Color from "@tiptap/extension-color";
import TextStyle from "@tiptap/extension-text-style";
import BulletList from "@tiptap/extension-bullet-list";
import Document from "@tiptap/extension-document";
import ListItem from "@tiptap/extension-list-item";
import OrderedList from "@tiptap/extension-ordered-list";
import Paragraph from "@tiptap/extension-paragraph";
import Text from "@tiptap/extension-text";
import {
  GetMomNameByNodeId,
  GetProjectNameInNodeId,
} from "../../masters/projects/queries/queries";
import { AtsAcLdgrProjects } from "../../masters/projects/queries/types";
import { nodeVar } from "../../../../../utils/commonQueryTypes";
import { AppContext } from "../../../../../context/context";
import { payloadTypes } from "../../../../../context/reducer";
import { handleUploadAndDownloadFile } from "../../../../../utils/Upload";
import AddMeetingNote from "../view/AddMeetingNote";
import { idAndFlagType } from "../../../../../utils/formTypes";
import { GetProjectsForMom } from "../../masters/subsidary/junctions/queries/queries";
import useServerDateandTime from "../../../../../customHooks/useServerDateandTime";
import LoadingModal from "../../../../pages/LoadingModal";

interface Props {
  discussed: boolean;
}

const PlanForProjects = ({ discussed }: Props) => {
  const navigate = useNavigate();
  const [value, setValue] = useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const [progress, setProgress] = useState(0);
  const [viewProjectDetails, setViewProjectDetails] = useState(false);
  const [markAttendance, setMarkAttendance] = useState(false);
  const [attendanceDetails, setAttendanceDetails] = useState(false);
  const [message, setMessage] = useState<msgType>(emptyMessage);
  const { customer_id, momID, projectID } = useUrlParams();
  const [addMeetingNote, setAddMeetingNote] =
    useState<idAndFlagType>(emptyIdAndModal);
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);

  const { serverDate } = useServerDateandTime();

  const { dispatch, state } = useContext(AppContext);

  const [GetProject, { data: projectNameData }] = useLazyQuery<
    { node: AtsAcLdgrProjects },
    nodeVar
  >(GetProjectNameInNodeId);

  const [GetMomDate, { data: momDateDetail }] = useLazyQuery<
    { node: AtsMomMaster },
    nodeVar
  >(GetMomNameByNodeId);

  const [checkAttMarked, { data: checkAttMarkedStatus }] = useLazyQuery<
    GetMomAttCountResult,
    GetMomAttCountVars
  >(GetMomAttCount);

  const [updateViewedStatus, { loading: updateViewedStatusLoading }] =
    useMutation<UpdateViewedStatusResult, UpdateViewedStatusVar>(
      UpdateViewedStatus,
      {
        onError: (e) => {
          setMessage({
            flag: true,
            message: e.message,
            operation: Operation.NONE,
          });
        },
      }
    );

  useEffect(() => {
    if (customer_id && momID && projectID) {
      checkAttMarked({
        variables: {
          customerID: customer_id,
          momID,
          projectID,
          latest: true,
        },
      });
    }
  }, [customer_id, momID, projectID, checkAttMarked]);

  const [AddPmu] = useMutation<AddPmuCommentsResult, AddPmuCommentsVars>(
    AddPmuComments,
    {
      onError: (e) => {
        setMessage({
          flag: true,
          message: e.message,
          operation: Operation.NONE,
        });
      },
    }
  );
  const [comment, setComment] = useState("");

  const { user_details } = useLoggedInUserDetails();

  const CustomDocument = Document.extend({
    content: "block+",
  });

  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        document: false, // disable default document
      }),
      CustomDocument,
      Paragraph,
      Text,
      BulletList,
      OrderedList,
      ListItem,
      TextAlign.configure({
        types: ["heading", "paragraph"],
      }),
      TextStyle,
      Color,
    ],
    onUpdate: ({ editor }) => {
      let html = editor.getHTML();
      html = html.replace(/<\/?p>/g, ""); //

      // Get HTML content and store in state
      setComment(editor.getText());
    },

    content: `<pre>${comment}</pre>`, // Initialize with comment state
  });

  const handleSave = () => {
    if (customer_id && momID && projectID && editor) {
      let filename = "";
      if (selectedFiles) {
        filename = selectedFiles
          .map((file, index) => {
            return `${customer_id}/momDetails/${momID}/${projectID}/${file.name}`;
          })
          .join(";");
      }
      AddPmu({
        variables: {
          customerID: customer_id!,
          momID,
          projectID,
          user_details,
          input: [
            {
              pmuComments: editor.getHTML(),
              pmuDocuments: filename,
            },
          ],
        },
        refetchQueries: [
          {
            query: GetMomDetails,
            variables: {
              customerID: customer_id,
              momID,
              projectID,
              latest: true,
            },
          },
          {
            query: GetProjectsForMom,
            variables: {
              customerID: customer_id,
              empID: user_details.id,
              momID,
              latest: true,
            },
          },
        ],
      }).then(({ data }) => {
        if (
          data &&
          data.AddPmuComments &&
          data.AddPmuComments.length &&
          data.AddPmuComments[0].id
        ) {
          if (selectedFiles) {
            const uploadFilePromise = Promise.all(
              selectedFiles.map((file, index) => {
                const fileExt = file.name.split(".").pop();
                handleUploadAndDownloadFile(
                  file,
                  `${customer_id}/momDetails/${momID}/${projectID}/${data.AddPmuComments[0].id}_${index}.${fileExt}`,
                  setProgress,
                  false
                );
              })
            );

            Promise.all([uploadFilePromise]).then(([sendMsgData]) => {
              if (sendMsgData) {
                setComment("");
                editor?.commands.clearContent();
                setSelectedFiles([]);
                setMessage({
                  flag: true,
                  message: "Comment added successfully",
                  operation: Operation.CREATE,
                });
              }
            });
          }
        }
      });
    }
  };

  useEffect(() => {
    if (projectID) {
      GetProject({
        variables: {
          id: projectID,
        },
      });
    }
  }, [projectID, GetProject]);

  useEffect(() => {
    if (momID) {
      GetMomDate({
        variables: {
          id: momID,
        },
      });
    }
  }, [momID, GetMomDate]);
  const handleClear = () => {
    if (!editor) return;

    editor?.commands.clearContent();
  };
  const handleClose = () => {
    if (message.flag && message.operation !== Operation.NONE) {
      handleClear();
    }
    setMessage(emptyMessage);
  };

  const allowToMarkAttendance = useMemo(() => {
    if (!serverDate || !momDateDetail) return false;
    const todayDate = new Date(serverDate);
    const meetingDate = new Date(momDateDetail?.node.meetingDate || "");
    return todayDate.getTime() >= meetingDate.getTime();
  }, [serverDate, momDateDetail]);

  const UpdateView = (viewed: boolean) => {
    if (customer_id && momID && projectID) {
      updateViewedStatus({
        variables: {
          user_details,
          customerID: customer_id,
          momID,
          projectID,
          viewed,
        },
        refetchQueries: [
          {
            query: GetProjectsForMom,
            variables: {
              customerID: customer_id,
              empID: user_details.id,
              momID,
              latest: true,
            },
          },
        ],
      }).then(({ data }) => {
        if (data && data.UpdateViewedStatus) {
          setMessage({
            flag: true,
            message: "Updated successfully",
            operation: Operation.UPDATE,
          });
          navigate(`/${customer_id}/minutesofmeeting/${momID}`);
        }
      });
    }
  };

  return (
    <>
      <Navbar NavType={LicenseTypes.DASHBOARD} />
      <Title>Project Minutes of Meeting</Title>
      <div className="plan-projects">
        <div className="plan-projects__flex row g-0">
          <div className="col plan-projects__subtitle">
            {projectNameData ? (
              <>
                <b>{projectNameData.node.name}</b>
                <span>({projectNameData.node.supplierName.desc})</span>
                <b className="font-green">
                  {toStandardDate(projectNameData.node.startDate)} -{" "}
                </b>
                <b className="font-red">
                  {toStandardDate(projectNameData.node.endDate)}
                </b>
              </>
            ) : null}

            <button
              className="plan-projects__subtitle--view"
              onClick={() => {
                if (projectID) {
                  dispatch({
                    type: payloadTypes.SET_PROJECT_ID,
                    payload: {
                      projectId: projectID,
                    },
                  });
                  setViewProjectDetails(!viewProjectDetails);
                }
              }}
            >
              View Project Details <img src={EyeWhite} alt="" />
            </button>
          </div>
          <div className="col-2 flex-end">
            <TextField
              label="Date"
              className="project-meetings__textfield"
              slotProps={{
                inputLabel: { shrink: true },
              }}
              type="date"
              disabled
              value={
                momDateDetail
                  ? toInputStandardDate(momDateDetail.node.meetingDate)
                  : ""
              }
            />
          </div>
        </div>
        <div className="plan-projects__block">
          <div className="plan-projects__block--row row g-0">
            <div className="col">
              <div className="plan-projects__block--tabs">
                <Tabs value={value} onChange={handleChange}>
                  <Tab label="Minutes of Meeting" value={0} {...a11yProps(0)} />
                  <Tab label="History" value={1} {...a11yProps(1)} />
                </Tabs>
              </div>
            </div>
            {state.empSubType === empType.PMU && (
              <div className="col-3 flex-end">
                {checkAttMarkedStatus &&
                Number(checkAttMarkedStatus.GetMomAttCount.empCount) +
                  Number(checkAttMarkedStatus.GetMomAttCount.inviteesCount) >
                  0 ? (
                  <div className="meeting-details--left--sub-h--att">
                    <b onClick={() => setAttendanceDetails(!attendanceDetails)}>
                      {Number(checkAttMarkedStatus.GetMomAttCount.empCount) +
                        Number(
                          checkAttMarkedStatus.GetMomAttCount.inviteesCount
                        )}{" "}
                      Members
                    </b>
                    <div>
                      <span className="font-green">Present</span>
                    </div>
                  </div>
                ) : state.empSubType === empType.PMU &&
                  allowToMarkAttendance ? (
                  <>
                    <div className="plan-projects__block--mark-att">
                      <b> Mark Attendance</b>{" "}
                      <AntSwitch
                        onChange={() => setMarkAttendance(!markAttendance)}
                      />
                    </div>
                  </>
                ) : null}
              </div>
            )}
          </div>

          <div className="plan-projects__block--tabpanel">
            <TabPanel value={value} index={0}>
              <Plan
                commentState={{ comment, setComment }}
                editor={editor}
                filesState={{ selectedFiles, setSelectedFiles }}
              />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <History />
            </TabPanel>
          </div>
        </div>
        <div className="row g-0">
          <div className="col">
            {state.empSubType === empType.VENDOR_MANAGER ? (
              <Button
                mode="addnew"
                onClick={() =>
                  setAddMeetingNote({
                    flag: true,
                    id: 0,
                  })
                }
              >
                {" "}
                Meeting Note
              </Button>
            ) : (
              <>
                {value === 0 ? (
                  <>
                    <Button
                      mode="save"
                      onClick={handleSave}
                      disabled={comment ? false : true}
                    />
                    <Button mode="clear" onClick={handleClear} />
                  </>
                ) : null}
              </>
            )}
            <Button
              mode="back"
              onClick={() => {
                if (value) {
                  setValue(0);
                } else navigate(-1);
              }}
            />
          </div>
          {/* <div className="col-2 flex-end">
            {state.empSubType === empType.PMU ? (
              discussed ? (
                <Button onClick={() => UpdateView(false)}>
                  Mark as Not Discussed
                </Button>
              ) : (
                <Button onClick={() => UpdateView(true)}>
                  Mark as Discussed
                </Button>
              )
            ) : null}
          </div> */}
        </div>
      </div>
      <CustomModal
        style={ViewModalStyles}
        isOpen={viewProjectDetails}
        onRequestClose={() => setViewProjectDetails(!viewProjectDetails)}
        contentComponent={
          <ViewParticularProjectDetails
            setModalFlag={setViewProjectDetails}
            projectId={state.projectId}
          />
        }
      />

      <CustomDrawer
        anchor="right"
        open={markAttendance}
        onClose={() => setMarkAttendance(!markAttendance)}
      >
        <EmployeeAttendance
          setModalFlag={setMarkAttendance}
          ldgrID={projectNameData ? projectNameData.node.supplierName.id : 0}
          name={projectNameData ? projectNameData.node.name : ""}
          operation={Operation.CREATE}
        />
      </CustomDrawer>
      <CustomDrawer
        anchor="right"
        open={attendanceDetails}
        onClose={() => setAttendanceDetails(!attendanceDetails)}
      >
        <AttendedEmployeesList
          setModalFlag={setAttendanceDetails}
          momId={momID!}
          latest={true}
        />
      </CustomDrawer>

      <CustomModal
        style={ViewAssetStylesRaiseTicket}
        isOpen={addMeetingNote.flag}
        onRequestClose={() => setAddMeetingNote(emptyIdAndModal)}
        contentComponent={
          <AddMeetingNote
            setModal={setAddMeetingNote}
            operation={Operation.CREATE}
            idModalFlag={addMeetingNote}
          />
        }
      />
      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <LoadingModal flag={updateViewedStatusLoading} />
    </>
  );
};

export default PlanForProjects;
